import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-648a816a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-16 mlr-16"
}
const _hoisted_2 = { class: "order-detail-header" }
const _hoisted_3 = { class: "color-default" }
const _hoisted_4 = { class: "fz-18 fw-bold" }
const _hoisted_5 = { class: "fz-14" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 重新激活 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 上一单 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 下一单 ")
const _hoisted_9 = { class: "order-detail-detail" }
const _hoisted_10 = { class: "order-detail-content" }
const _hoisted_11 = { class: "order-detail-content__item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail-content__title" }, "基础信息", -1))
const _hoisted_13 = { class: "order-detail-content__desc" }
const _hoisted_14 = { class: "flex mt-16" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail__label" }, "发起人：", -1))
const _hoisted_16 = { class: "flex mt-16" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail__label" }, "发起时间：", -1))
const _hoisted_18 = { class: "flex mt-16" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail__label" }, "受理网点：", -1))
const _hoisted_20 = { class: "flex mt-16" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail__label" }, "工单状态：", -1))
const _hoisted_22 = { class: "order-detail__status" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-dot" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "status-dot" }, null, -1))
const _hoisted_25 = { class: "flex mt-16" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail__label" }, "物流状态：", -1))
const _hoisted_27 = {
  key: 0,
  class: "flex mt-16"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail__label" }, "内物品名：", -1))
const _hoisted_29 = {
  key: 0,
  class: "order-detail-content__item"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail-content__title" }, "售后内容", -1))
const _hoisted_31 = { class: "order-detail-content__desc" }
const _hoisted_32 = { class: "flex mt-16" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail__label" }, "收件人姓名：", -1))
const _hoisted_34 = { class: "flex mt-16" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail__label" }, "收件人手机号：", -1))
const _hoisted_36 = {
  key: 0,
  class: "flex mt-16"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail__label" }, "地址：", -1))
const _hoisted_38 = { class: "order-detail-content__item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail-content__title" }, "问题描述", -1))
const _hoisted_40 = { class: "order-detail-content__rs" }
const _hoisted_41 = {
  key: 1,
  class: "order-detail-content__item"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail-content__title" }, "已上传图片", -1))
const _hoisted_43 = { class: "order-detail-content__rs flex" }
const _hoisted_44 = {
  key: 2,
  class: "order-detail-content__item"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail-content__title" }, "已上传音频", -1))
const _hoisted_46 = { class: "order-detail-content__rs flex" }
const _hoisted_47 = {
  key: 3,
  class: "order-detail-content__item"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "order-detail-content__title" }, "物流轨迹", -1))
const _hoisted_49 = { class: "order-detail-content__rs" }
const _hoisted_50 = { class: "order-detail-process" }
const _hoisted_51 = {
  key: 0,
  class: "order-detail-process__btn"
}
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" 追加描述信息 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MediaList = _resolveComponent("MediaList")!
  const _component_OrderTravel = _resolveComponent("OrderTravel")!
  const _component_progressList = _resolveComponent("progressList")!
  const _component_BaseLayout = _resolveComponent("BaseLayout")!

  return (_openBlock(), _createBlock(_component_BaseLayout, null, {
    default: _withCtx(() => [
      (_ctx.detailData.notice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_alert, {
              title: _ctx.detailData.notice,
              type: "warning",
              "show-icon": "",
              closable: false
            }, null, 8, ["title"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "order-detail__container",
        style: _normalizeStyle({ height: _ctx.detailData.notice ? 'calc(100% - 68px)': '100%' })
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, "售后类型：" + _toDisplayString(_ctx.detailData.orderTypeName), 1),
            _createElementVNode("div", _hoisted_5, "运单号：" + _toDisplayString(_ctx.detailData.billCode), 1)
          ]),
          _createElementVNode("div", null, [
            (_ctx.detailData.orderStatusCode == 'third_finished')
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  size: "small",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleReLaunch(_ctx.detailData.billCode, 'restart')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.showIndex>0)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 1,
                  class: "ml-8",
                  to: `/admin/after-sales/order-detail?workCode=${_ctx.showList[_ctx.showIndex-1].workCode}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      plain: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true),
            (_ctx.showIndex<_ctx.showLen-1)
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 2,
                  class: "ml-8",
                  to: `/admin/after-sales/order-detail?workCode=${_ctx.showList[_ctx.showIndex+1].workCode}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      size: "small",
                      plain: ""
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["to"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", null, _toDisplayString(_ctx.detailData.linkMan), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", null, _toDisplayString(_ctx.momentFormat(_ctx.detailData.createTime, "YYYY/MM/DD HH:mm:ss")), 1)
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", null, _toDisplayString(_ctx.detailData.acceptSite), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["status-text", { 'status-active': _ctx.detailData.orderStatusCode == 'third_created'}])
                    }, "已创建", 2),
                    _hoisted_23,
                    _createElementVNode("div", {
                      class: _normalizeClass(["status-text", { 'status-active': _ctx.detailData.orderStatusCode == 'third_processing'}])
                    }, "处理中", 2),
                    _hoisted_24,
                    _createElementVNode("div", {
                      class: _normalizeClass(["status-text", { 'status-active': _ctx.detailData.orderStatusCode == 'third_finished'}])
                    }, "已完结", 2)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", null, _toDisplayString(_ctx.mapValueFormat(_ctx.detailData.logisticsStatus, _ctx.getStoreMapWithDicKey('bill_list_status_type'))), 1)
                ]),
                false
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _hoisted_28,
                      _createElementVNode("div", null, _toDisplayString(_ctx.detailData.itemName), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (['modify_recipient_contact_number', 'edit_delivery_address'].includes(_ctx.detailData.orderType))
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _hoisted_33,
                      _createElementVNode("div", null, _toDisplayString(_ctx.detailData.newReceiverName), 1)
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _createElementVNode("div", null, _toDisplayString(_ctx.detailData.newReceiverPhone), 1)
                    ]),
                    (_ctx.detailData.orderType == 'edit_delivery_address')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _hoisted_37,
                          _createElementVNode("div", null, _toDisplayString(_ctx.detailData.newReceiverAddress), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.detailData.description || "没有提交问题描述"), 1)
            ]),
            (_ctx.detailData.pictureList)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(_component_MediaList, {
                      appId: _ctx.ZFS.SDAppid,
                      originFiles: _ctx.detailData.pictureList,
                      readOnly: ""
                    }, null, 8, ["appId", "originFiles"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.detailData.audioList)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _hoisted_45,
                  _createElementVNode("div", _hoisted_46, [
                    _createVNode(_component_MediaList, {
                      appId: _ctx.ZFS.SDAppid,
                      originFiles: _ctx.detailData.audioList,
                      readOnly: ""
                    }, null, 8, ["appId", "originFiles"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.dialog.visible && _ctx.dialog.orderInfo && _ctx.dialog.orderInfo.traceRecordCOList && _ctx.dialog.orderInfo.traceRecordCOList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("div", _hoisted_49, [
                    _createVNode(_component_OrderTravel, {
                      orderInfo: _ctx.dialog.orderInfo,
                      loading: _ctx.dialog.loading
                    }, null, 8, ["orderInfo", "loading"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createVNode(_component_progressList, {
              progressInfoList: _ctx.detailData.processingProgressInfoList,
              acceptSite: _ctx.detailData.acceptSite,
              appId: _ctx.ZFS.SDAppid
            }, null, 8, ["progressInfoList", "acceptSite", "appId"]),
            (_ctx.detailData.orderStatusCode != 'third_finished')
              ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "small",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleReLaunch(_ctx.detailData.billCode, 'append')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_52
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ], 4)
    ]),
    _: 1
  }))
}